<template>
<div class="container mt-5" style="height:300px">
    <!-- Modal loader start  -->
     <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('contrat.payment_success.title') }}</span>
    </div>

    <!-- <div class="text-xs-center">
        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="orange" dark>
                <v-card-text>
                    {{ $t('contrat.payment_success.title') }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div> -->
</div>
</template>

<script>
import Api from "../services/Api";
import store from '../store/store'
import axios from 'axios'
import Delivery from '../services/Delivery'
import PushInDataLayer from '../services/TagManager';

export default {
    data() {
        return {
            Mano: null,
            dialogLoading: false,
            Contrat_provisoire: null,
            TheBranche: null,
            brancheName: null,
            ThePartner: null,
            proprio: null,
            numDevis: null,
            ToastTabSucess: { // Customized options for success toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fitToScreen: true,
                type: "success",
                className: "custom-success-class"
            },
            ToastTabError: { // Customized options for error toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fitToScreen: true,
                type: "error"
            },
        }
    },
    created() {
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 1000)
    },
    
    beforeDestroy() 
    {
        localStorage.removeItem('Recurrentpayment')
    },
    
    methods: {

        BlockPaymentLink() {
            let id = localStorage.getItem('PaymentlinkId');
            if (typeof id !== 'undefined' && typeof id == 'string') {
                Api().post('paymentLink/block/link', {
                        id: id
                    })
                    .then(response => {
                        localStorage.setItem('Blocked Link', JSON.stringify(response.data))
                    })
            }
        },

        // on envoie les infos du payement au partner dedié si retour == OK on crée un contrat à la suite
        payement_end: function (params) 
        {
            this.purchasePushin()
            
            Api().post('contrat/attestation/retrait',{ 
                numero: params.numeroDevis,
                dateEffet: params.dateEffet,
                dateEcheance: params.dateEcheance
            })
                .then(response => {
                    if(response.data.count >= 1)
                    {
                        if (localStorage.getItem('adressliv') !== '')
                        {
                            Delivery(this.$store.state.devispayement.devis)
                        } 
                        this.BlockPaymentLink();
                        this.sendmailAdmin();
                        this.$store.dispatch('setNewcontrat', response.data.contrats[0]);
                        this.$store.dispatch('setDevisPayement', null);
                        this.$router.push('/contrat/ok');
                    }else{
                         this.$router.push('/payement/failed')
                    }
                })
                .catch(e => {
                    this.$router.push('/payement/failed')
                })
        },

        fetchEventsList()
        {
            this.Mano = this.Mano - 1;
            if (this.Mano == 0) {
                clearInterval(this.timer);
                this.CheckUpayRes()
            }
        },

        /*====================================*/
        /*Push purchase event in the dataLayer*/
        /*====================================*/ 
        purchasePushin()
        {
            if(this.$store.state.devispayement !== null && typeof this.$store.state.devispayement !== 'undefined')
            {
                try {
                    let purchasePushin = JSON.parse(localStorage.getItem('purchasePushin'))
                    purchasePushin.ecommerce.transaction_id = (this.$store.state.devispayement.devis.numeroDevis).replace(/[/]/g, '_');
                    PushInDataLayer(purchasePushin)
                } catch (error) {
                    console.log(error)
                }
            }
        },

        CheckUpayRes() 
        {
            if (this.$store.state.devispayement !== null && typeof this.$store.state.devispayement !== 'undefined') 
            {
               if(localStorage.getItem('Recurrentpayment') && localStorage.getItem('Recurrentpayment').toString() == 'true')
                {
                    this.saveRecurentpay()
                }else
                {                      
                    this.payement_end(this.$store.state.devispayement.devis)
                }
            }
        },

        /*== Save recurent payment for Sunu EducationPlus ==*/
        saveRecurentpay()
        {
            const item = JSON.parse(localStorage.getItem('ReccurentPayItem'))
            let numcommande = (this.$store.state.devispayement.numero_police).replace(/[/]/g, '_');

            const data = {
                userid : store.state.user._id,
                numero: item.numero_police,
                partenaireid : item.partenaireid._id,
                brancheid : item.brancheid._id,
                contratid : item._id,
            }
                    
            Api().get("upay/upayres/"+numcommande)
                .then(res => {
                    if (res.data.transaction_id) 
                    {
                        Api().post('recurrentpay/create', data)
                            .then((result) => {
                                localStorage.removeItem('Recurrentpayment')
                                localStorage.removeItem('ReccurentPayItem')
                                this.dialogLoading = false
                                this.$toasted.show("Votre paiement a été pris en compte ! ", this.ToastTabSucess);
                                setTimeout((() => this.$router.push('/dashboard') ), 5000)
                        }).catch((err) => {
                                localStorage.removeItem('Recurrentpayment')
                                localStorage.removeItem('ReccurentPayItem')
                                this.dialogLoading = false
                                this.$toasted.show("Erreur lors du paiement !", this.ToastTabSucess);
                                setTimeout((() => this.$router.push('/dashboard') ), 5000)
                        });
                    }
                })
                .catch(e => {
                    this.$router.push('/payement/failed')
                })
        },

        //Recuperation URL pour l Envoie sms au client
        sendmailAdmin: function () 
        {
            let amount = localStorage.getItem('amount');
            let numdeveis = localStorage.getItem('numdevis');
            const body = {
                sender_email: "Assuraf Logs Upay",
                sujet: "Paiement de contrat par Upay ",
                message: "Paiement de " + amount + " FCFA à assuraf.com a bien été validé par \n " + "Nom et Prenom : " + this.$store.state.user.nom + " " + this.$store.state.user.prenom + "\n N° devis : " + numdeveis + "\n" + "Date :" + Date()

            };
            Api().post('messaegeadmin/sendMail', body)
                .then(res => {
                    (res)
                })
                .catch(err => {
                    (err)
                })

        },

        //Envoie sms au client
        sendsmsclient: function (contrat, branche) {
            let host = '';
            let numcli = this.$store.state.user.telephone_port;
            let adresstosend = numcli.substring(numcli.length - 9);
            if (branche == 'Santé') {
                host = 'https://api.assuraf.com/api/uploads/Contrat_provisoir_Sante_' + contrat._id + ".pdf"
            } else {
                host = 'https://api.assuraf.com/api/uploads/Contrat_provisoir_' + branche + '_' + contrat._id + ".pdf"
            }
            const orangeToken = process.env.VUE_APP_ORANGE_SMS_TOKEN || '';
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': orangeToken,
            };
            if (orangeToken) {
                axios.defaults.headers.common['Authorization'] = "Bearer " + orangeToken;
            }
            const textclient = {
                outboundSMSMessageRequest: {

                    address: "tel:+221" + adresstosend,
                    senderAddress: "tel:+221772981201",
                    outboundSMSTextMessage: {
                        message: "Assuraf vous informe que votre demande a été bien finalisée et votre attestation est disponible ici " + " " + host
                    },
                }
            };

            axios.post('https://api.orange.com/smsmessaging/v1/outbound/tel:+221772981201/requests', textclient, headers)
                .then(res => {
                    (res)
                })
                .catch(err => {
                    (err)
                })

        },

    },

    mounted() {
        window.scrollTo(0, 0);
        if (this.$store.state.orderid) 
        {
            if (this.$store.state.devispayement || this.$store.state.devispayementDiffere || this.$store.state.devis) {
                this.Mano = 10;
                this.dialogLoading = true
            } else {
                this.$router.push('/')
            }

        } else {
            this.$router.push('/')
        }
    }
};
</script>

<style scoped>
.row-container {
    background: white;
    padding: auto;
    margin: auto;
}

span {
    font-weight: bold;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
